
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/tickets",
      function () {
        return require("private-next-pages/account/tickets/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/tickets"])
      });
    }
  